import React, { useEffect, useState } from "react";
import { Box, Card, CardContent, Typography, Alert, FormControl, InputLabel, Select, MenuItem, Stack, IconButton } from "@mui/material";

import HistorylogsTable from "./HistorylogsTable";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { AppDispatch, RootState } from "../../redux/store/appStore";
import { getLogs } from "../../redux/slices/historyLogs/logSlice";
import { LocalizationProvider, MobileDatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import EastIcon from "@mui/icons-material/East";
import dayjs, { Dayjs } from "dayjs";
import Error from "../error/error";
import HighlightOffIcon from '@mui/icons-material/HighlightOff';


const HistoryLogs: React.FC<any> = () => {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [openRow, setOpenRow] = useState<number | null>(null);
  const [filters, setFilters] = useState({ type: "All", startDate: null, endDate: null });
  const [startDate, setStartDate] = useState<Dayjs | null>(null);
  const [endDate, setEndDate] = useState<Dayjs | null>(null);


  const dispatch = useDispatch<AppDispatch>();
  const { logs, count, getLogsStatus, error } = useSelector((state: RootState) => state.logs);
  const { id } = useParams()

  useEffect(() => {
    if (id) {
      dispatch(getLogs({ project_id: id, page: page + 1, rows_per_page: rowsPerPage, type: filters.type, 
        start_date: startDate ? dayjs(startDate).format("YYYY-MM-DD") : null, 
        end_date: endDate ? dayjs(endDate).format("YYYY-MM-DD") : null  
      }));
    }
  }, [dispatch, id, filters.type, endDate, page, rowsPerPage]);

  const handleChangePage = (_: any, newPage: number) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleFilterChange = (e: any) => {
    const { name, value } = e.target;
    setFilters((prev) => ({ ...prev, [name as string]: value }));
    setPage(0);
  };

  const handleStartDateChange = (date: Dayjs | null) => {
    setStartDate(date);
  };

  const handleEndDateChange = (date: Dayjs | null) => {
    setEndDate(date);
  };
  
  const clearFilter = () => {
    setFilters({ type: "All", startDate: null, endDate: null });
    setStartDate(null);
    setEndDate(null);
  }


  return (
    <Box p={2}>
      <Card sx={{ boxShadow: 0, borderRadius: 3 }}>
        <CardContent>
          <Typography variant="h6" fontWeight="bold" gutterBottom style={{ fontFamily: "montserrat" }}>
            Logs
          </Typography>

          <Alert severity="warning" sx={{ mb: 2 }}>
            Note: Change history is retained for the last 2 months only.
          </Alert>


          <Stack direction="row" spacing={2} mb={2}>
            <FormControl size="small" sx={{ minWidth: 200 }}>
              <InputLabel style={{ fontFamily: "montserrat" }}>Select Type</InputLabel>
              <Select
                name="type"
                value={filters.type}
                label="Select Type"
                onChange={handleFilterChange}
              >
                {["All","Task", "Config", "Users", "Test", "Stage", "Workflow", "Project"].map((t) => (
                  <MenuItem key={t} value={t} style={{ fontFamily: "montserrat" }}>
                    {t}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                <MobileDatePicker
                  value={startDate}
                  onChange={handleStartDateChange}
                  format="DD-MM-YYYY"
                  slotProps={{
                    textField: {
                      size: "small",
                      placeholder: "Start Date",
                    } as any,
                  }}
                />

                <EastIcon sx={{ fontSize: "16px" }} />

                <MobileDatePicker
                  value={endDate}
                  onChange={handleEndDateChange}
                  format="DD-MM-YYYY"
                  minDate={startDate || undefined}
                  slotProps={{
                    textField: {
                      size: "small",
                      placeholder: "End Date",
                    } as any,
                  }}
                />
                <IconButton onClick={clearFilter} size="small">
                  <HighlightOffIcon fontSize="small" />
                </IconButton>
              </div>
            </LocalizationProvider>
          </Stack>


          {getLogsStatus === "FAILED" ?
            <Error message="There are Some Error Occured. Come back later" /> :
            <HistorylogsTable
              logs={logs}
              count={count}
              page={page}
              rowsPerPage={rowsPerPage}
              openRow={openRow}
              onToggleRow={(id) => setOpenRow(openRow === id ? null : id)}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              getLogsStatus={getLogsStatus}
            />}
        </CardContent>
      </Card>
    </Box>
  );
}

export default HistoryLogs;